import {FilterValuesJoinType, IFilter} from 'plugins/modules/filter/types';
import {isBrowserContext} from 'core/helpers';
import {FILTER_URL_PARAMS, FILTER_URL_SLUG} from 'plugins/modules/filter/constants';
import {PAGINATION_PARAM} from 'core/constants';

const {AND, FROM, OR, TO} = FILTER_URL_PARAMS;

interface IFiltersData {
    code: string;
    value: string;
    valuesJoinType: FilterValuesJoinType;
}

export class FiltersToUrl {
    constructor(filters: IFilter[]) {
        if (!isBrowserContext()) {
            throw new Error('Данный класс предназначен для работы только в браузере!');
        }

        this.init(filters);
    }

    private pathnameBase: string = '';
    private pathnameFilters: string = '';
    private filters: IFilter[] = [];
    private filtersDataList: IFiltersData[] = [];

    pathName: string = '';

    private getQuery = () => {
        const urlSP = new URLSearchParams(window.location.search);
        urlSP.delete(PAGINATION_PARAM);

        const query = urlSP.toString();

        return query ? `?${query}` : '';
    };

    private init = (filters: IFilter[]) => {
        this.setFilters(filters);
        this.setPathnameBase();
        this.setFiltersDataList();
        this.setPathnameFilters();
        this.setPathname();
    };

    private setFilterAnd = ({code, values, valuesJoinType}: IFilter) => {
        const value = values.join(`-${AND}-`);

        this.filtersDataList.push({
            code,
            value,
            valuesJoinType,
        });
    };

    private setFilterOr = ({code, values, valuesJoinType}: IFilter) => {
        const value = values.join(`-${OR}-`);

        this.filtersDataList.push({
            code,
            value,
            valuesJoinType,
        });
    };

    private setFilterRange = ({code, values, valuesJoinType}: IFilter) => {
        let value = '';

        const [from, to] = values;

        const isFromExists = from !== undefined && '' !== from;
        const isToExists = to !== undefined && '' !== to;

        if (!isFromExists && !isToExists) {
            return;
        }

        if (isFromExists) {
            value += `${FROM}-${from}`;
        }

        if (isToExists) {
            if (isFromExists) {
                value += '-';
            }

            value += `${TO}-${to}`;
        }

        this.filtersDataList.push({
            code,
            value,
            valuesJoinType,
        });
    };

    private setFilterSingleValue = ({code, values, valuesJoinType}: IFilter) => {
        const value = values[0];

        if (value === undefined) {
            return;
        }

        this.filtersDataList.push({
            code,
            value,
            valuesJoinType,
        });
    };

    private setFilters = (filters: IFilter[]) => {
        this.filters = filters.filter(({values}) => values.length);
    };

    private setFiltersDataList = () => {
        this.filters.forEach((filter) => {
            const {valuesJoinType} = filter;

            if (valuesJoinType === FilterValuesJoinType.AND) {
                this.setFilterAnd(filter);

                return;
            }

            if (valuesJoinType === FilterValuesJoinType.OR) {
                this.setFilterOr(filter);

                return;
            }

            if (valuesJoinType === FilterValuesJoinType.RANGE) {
                this.setFilterRange(filter);

                return;
            }

            if (valuesJoinType === FilterValuesJoinType.SINGLE_VALUE) {
                this.setFilterSingleValue(filter);
            }
        });
    };

    private setPathname = () => {
        const query = this.getQuery();

        if (!this.pathnameFilters) {
            this.pathName = `${this.pathnameBase}${query}`;

            return;
        }

        this.pathName = `${this.pathnameBase}${FILTER_URL_SLUG.replaceAll('/', '')}/${this.pathnameFilters}${query}`;
    };

    private setPathnameFilters = () => {
        this.filtersDataList.forEach(({code, value}, index) => {
            const isLastFilter = index === this.filtersDataList.length - 1;
            this.pathnameFilters += `${code}-${value}${isLastFilter ? '' : '/'}`;
        });
    };

    private setPathnameBase = () => {
        let pathnameBase = window.location.pathname.split(FILTER_URL_SLUG)[0];

        if (!pathnameBase.endsWith('/')) {
            pathnameBase += '/';
        }

        this.pathnameBase = pathnameBase;
    };
}
